import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Signin from '../views/login/sign-in.vue'
import Register from '../views/register.vue'
import Table from '../views/livetable.vue'
import visitsTable from '../views/visitsTable.vue'
import multiTable from '../views/AnalyticsFieldTable.vue'
import BigScreen from '../views/BigScreen.vue'
import reply from '../views/live-reply.vue'
import LiveOverview from '../views/live-overview.vue'
import LiveBehaviorAnalysis from '../views/live-behavior-analysis.vue'
import CustomerContact from '../views/customer-contact.vue'
import Settings from '../views/settings.vue'
import PromotionEditor from '../views/promotion.vue'
import PromotionList from '../views/promotion-list.vue'
import PromotionCampaignBills from '../views/promotion-campaign-bills.vue'
import PromotionTotalBills from '../views/promotion-total-bills.vue'
import PromotionCheckout from '../views/promotion-checkout.vue'
import Notifications from '../views/notifications.vue'

import CameraTest from '@/views/CameraTest.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/customer-contact',
    name: 'customer-contact',
    component: CustomerContact
  },
  {
    path: '/promotion',
    name: 'promotion-list',
    component: PromotionList
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: Notifications
  },
  {
    path: '/promotion/create',
    name: 'promotion-create',
    component: PromotionEditor
  },
  {
    path: '/promotion/bills',
    name: 'promotion-total-bills',
    component: PromotionTotalBills
  },
  {
    path: '/promotion/:id/bills',
    name: 'promotion-campaign-bills',
    component: PromotionCampaignBills
  },
  {
    path: '/promotion/:id/edit',
    name: 'promotion-edit',
    component: PromotionEditor
  },
  {
    path: '/promotion/checkout',
    name: 'promotion-checkout',
    component: PromotionCheckout
  },
  {
    path: '/camera-test',
    name: 'CameraTest',
    component: CameraTest
  },
  {
    path: '/signin',
    name: 'sign-in',
    component: Signin
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/livetable',
    name: 'livetable',
    component: Table
  },
  {
    path: '/visitsTable',
    name: 'visitsTable',
    component: visitsTable
  },
  {
    path: '/multiTable',
    name: '/multiTable',
    component: multiTable
  },
  {
    path: '/BigScreen',
    name: 'BigScreen',
    component: BigScreen
  },
  {
    path: '/live-overview',
    name: 'live-overview',
    component: LiveOverview
  },
  {
    path: '/behavior-analysis',
    name: 'behavior-analysis',
    component: LiveBehaviorAnalysis
  },
  {
    path: '/live-reply',
    name: 'live-reply',
    component: reply
  },
  {
    path: '/streamer',
    redirect: '/live-reply'
  },
  {
    path: '/streamer-agora',
    redirect: '/live-reply'
  },
  {
    path: '/streamer-tencent',
    redirect: '/live-reply'
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
